import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { MemberDto } from '../../../services/dtos/member.dto';

/**
 * Dialog de formulaire
 *
 * @param {boolean} props.open - Etat du dialog
 * @param {function} props.handleClose - Fonction de fermeture du dialog
 * @param {Object} props.userInfos - Informations de l'utilsateur
 */
export default function ListMembersCommissionDialogUi(
    props: Readonly<{
        open: boolean;
        members?: Array<MemberDto>;
        handleClose: () => void;
    }>
) {
    // Affichage de la liste des utilisateurs
    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            className={'proposal-confirmation-dialog'}
            sx={{ padding: '0px' }}
        >
            <DialogTitle sx={{ borderRadius: '0px' }} variant={'h5'}>
                Liste des membres
            </DialogTitle>
            <DialogContent>
                {/* Le texte sera adapté selon s'il s'agit d'un refus ou d'une validation*/}
                <Grid container spacing={1} sx={{ marginTop: '5px' }}>
                    {props.members?.map(member => (
                        <Grid
                            item
                            xs={12}
                            key={member.lastName + ' ' + member.firstName}
                            sx={{ backgroundColor: '#e0e0e0', marginBottom: '5px' }}
                        >
                            <Typography variant={'h5'}>{member.lastName + ' ' + member.firstName}</Typography>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Typography variant={'button'}>
                    <Button variant="contained" onClick={props.handleClose} data-testid={'close'}>
                        Fermer
                    </Button>
                </Typography>
            </DialogActions>
        </Dialog>
    );
}
